import React from 'react';

import {RouteData} from '../types';
import {
  GALLERY_PATH,
  GALLERY_PATH_SEGMENT,
  OLD_GALLERY_DISCUSSION_EDIT_PATH,
  OLD_GALLERY_DISCUSSION_VIEW_PATH,
  OLD_REPORT_PAGE_EDIT_PATH,
  OLD_REPORT_PAGE_VIEW_PATH,
  REPORT_PAGE_EDIT_PATH,
  REPORT_PAGE_VIEW_PATH,
  REPORT_PAGE_VIEW_PUBLISHED_WORK_PATH,
} from './reportPaths';

export const FULLY_CONNECTED_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'FullyConnected',
    },
    isPrivateRoute: false,
    path: GALLERY_PATH,
    RouteComponent: React.lazy(() => import('../../pages/FC')),
  },
  {
    path: '/fullyconnected',
    redirect: `/${GALLERY_PATH_SEGMENT}`,
  },
  {
    path: '/fc',
    redirect: `/${GALLERY_PATH_SEGMENT}`,
  },
  {
    path: '/gallery',
    redirect: `/${GALLERY_PATH_SEGMENT}`,
  },
];

export const REPORT_ROUTES_DATA: RouteData[] = [
  {
    // This old edit report page route will be redirected to /reportlist
    additionalProps: {
      allowIframes: false,
      routeName: 'OldReportPageEdit',
    },
    exact: true,
    isPrivateRoute: false,
    path: OLD_REPORT_PAGE_EDIT_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ),
  },
  {
    // This old view report page route will be redirected to /reportlist
    additionalProps: {
      allowIframes: false,
      routeName: 'OldReportPageView',
    },
    exact: true,
    isPrivateRoute: false,
    path: OLD_REPORT_PAGE_VIEW_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ),
  },
  {
    additionalProps: {
      allowIframes: true,
      routeName: 'ReportEdit',
    },
    exact: true,
    isPrivateRoute: false,
    path: REPORT_PAGE_EDIT_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ),
  },
  {
    additionalProps: {
      allowIframes: true,
      routeName: 'ReportView',
    },
    exact: true,
    isPrivateRoute: false,
    path: REPORT_PAGE_VIEW_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ),
  },
  {
    additionalProps: {
      allowIframes: true,
      routeName: 'ReportViewPublished',
    },
    exact: true,
    isPrivateRoute: false,
    path: REPORT_PAGE_VIEW_PUBLISHED_WORK_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'FullyConnectedDiscussionEdit',
    },
    exact: true,
    isPrivateRoute: false,
    path: OLD_GALLERY_DISCUSSION_EDIT_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'FullyConnectedDiscussionView',
    },
    exact: true,
    isPrivateRoute: false,
    path: OLD_GALLERY_DISCUSSION_VIEW_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ReportPage/ReportPageRouter')
    ),
  },
];
